// hooks/useProjectManagement.js

import { useEffect, useState } from "react";
import { toast } from "react-toastify";

import {
  getAllProjects,
  createProject,
  updateProject,
  deleteProject,
  uploadPropertyImages,
} from "../../../services/projectService";


export const useProjectManagement = () => {
  const [projects, setProjects] = useState([]);
  const [loading, setLoading] = useState(false);

  const loadProjects = async () => {
    try {
      setLoading(true);

      const res = await getAllProjects();

      setProjects(Array.isArray(res?.projects) ? res.projects : []);
    } catch (error) {
      toast.error("Không thể tải danh sách dự án");
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    loadProjects();
  }, []);

  const create = async (payload) => {
    await createProject(payload);
    await loadProjects();
  };

  const update = async (id, payload) => {
    await updateProject(id, payload);
    await loadProjects();
  };

  const remove = async (id) => {
    await deleteProject(id);
    await loadProjects();
  };

  return {
    projects,
    loading,
    create,
    update,
    remove,
    uploadPropertyImages,
  };
};